export const SET_SYSTEM_NOTIFICATION_MODAL_VISIBLE = 'SYSTEM/SET_SYSTEM_NOTIFICATION_MODAL_VISIBLE';
